const UserGroupStructure = {
    userId: "",
    name: {
      first: "",
      middle: "",
      last: ""
    },
    imageUrl: "",
    gender: "",
    ethenic: "",
    email: "",
    password: "",
    mobileNumber: "",
    devices: [],
    dateOfBirth: "", // ISO string format (e.g. "2025-01-01T00:00:00Z")
    address: {
      street: "",
      city: "",
      state: "",
      country: "",
      postalCode: ""
    },
    consent: {
      accepted: false,
      date: "" // ISO string
    },
    payAccounts: {
      accountId: "",
      provider: "",
      linkedOn: "" // ISO string
    },
    profiles: [], // array of profile objects
    nProfCount: 0,
    nBlogs: 0,
    blogs: [], // array of blog objects
    nAudios: 0,
    audios: [], // array of audio objects
    nVideos: 0,
    videos: [], // array of video objects
    nImages: 0,
    images: [], // array of image objects
    nReels: 0,
    reels: [], // array of short video objects
    connections: {
      friendCount: 0,
      admirerCount: 0,
      admireeCount: 0,
      collaborateCount: 0,
      groupsCount: 0,
      groups: [
        {
          groupName: "",
          groupId: "",
          imageUrl: "",
          createdOn: "", // ISO string
          createdBy: "",
          groupUUID: "",
          members: [],
          nMembers: 0,
          
          pastAbuse: false,
          canMessage: false,
          canAudio: false,
          canVideo: false
        }
      ],
      friends: [],
      collaborator: [],
      admirer: []
    }
  };
  